export const EditorCardsPlaceholderImage = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => {
  return (
    <svg
      viewBox="0 0 591 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="591" height="200" fill="#F8F9F9" />
      <line
        x1="237.666"
        y1="120.145"
        x2="256.149"
        y2="120.145"
        stroke="#D9D9D9"
        strokeWidth="1.5"
      />
      <line
        x1="234.817"
        y1="114.583"
        x2="258.987"
        y2="114.583"
        stroke="#D9D9D9"
        strokeWidth="1.5"
      />
      <path d="M233.398 106.715H260.412" stroke="#A0A0A0" strokeWidth="2" />
      <rect
        x="225.368"
        y="70.5"
        width="43.0748"
        height="59"
        rx="3.5"
        stroke="#D9D9D9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M224.868 74V99.2683H268.943V74C268.943 71.7909 267.152 70 264.943 70H228.868C226.659 70 224.868 71.7909 224.868 74Z"
        fill="#D9D9D9"
        fillOpacity="0.35"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M239.086 92.683H257.095L249.591 81.8699L245.089 88.0488L243.588 86.5041L239.086 92.683ZM241.246 82.736C241.668 83.1705 242.241 83.4147 242.838 83.4147C243.435 83.4147 244.007 83.1705 244.43 82.736C244.852 82.3015 245.089 81.7121 245.089 81.0976C245.089 80.4831 244.852 79.8937 244.43 79.4592C244.007 79.0246 243.435 78.7805 242.838 78.7805C242.241 78.7805 241.668 79.0246 241.246 79.4592C240.824 79.8937 240.587 80.4831 240.587 81.0976C240.587 81.7121 240.824 82.3015 241.246 82.736Z"
        fill="#A0A0A0"
      />
      <line
        x1="286.741"
        y1="120.145"
        x2="305.224"
        y2="120.145"
        stroke="#D9D9D9"
        strokeWidth="1.5"
      />
      <line
        x1="283.893"
        y1="114.583"
        x2="308.063"
        y2="114.583"
        stroke="#D9D9D9"
        strokeWidth="1.5"
      />
      <path d="M282.474 106.715H309.487" stroke="#A0A0A0" strokeWidth="2" />
      <rect
        x="274.443"
        y="70.5"
        width="43.0748"
        height="59"
        rx="3.5"
        stroke="#D9D9D9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M273.943 74V99.2683H318.018V74C318.018 71.7909 316.227 70 314.018 70H277.943C275.734 70 273.943 71.7909 273.943 74Z"
        fill="#D9D9D9"
        fillOpacity="0.35"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M288.161 92.683H306.17L298.666 81.8699L294.164 88.0488L292.663 86.5041L288.161 92.683ZM290.321 82.736C290.743 83.1705 291.316 83.4147 291.913 83.4147C292.51 83.4147 293.083 83.1705 293.505 82.736C293.927 82.3015 294.164 81.7121 294.164 81.0976C294.164 80.4831 293.927 79.8937 293.505 79.4592C293.083 79.0246 292.51 78.7805 291.913 78.7805C291.316 78.7805 290.743 79.0246 290.321 79.4592C289.899 79.8937 289.662 80.4831 289.662 81.0976C289.662 81.7121 289.899 82.3015 290.321 82.736Z"
        fill="#A0A0A0"
      />
      <line
        x1="335.815"
        y1="120.145"
        x2="354.298"
        y2="120.145"
        stroke="#D9D9D9"
        strokeWidth="1.5"
      />
      <line
        x1="332.967"
        y1="114.583"
        x2="357.137"
        y2="114.583"
        stroke="#D9D9D9"
        strokeWidth="1.5"
      />
      <path d="M331.548 106.715H358.561" stroke="#A0A0A0" strokeWidth="2" />
      <rect
        x="323.518"
        y="70.5"
        width="43.0748"
        height="59"
        rx="3.5"
        stroke="#D9D9D9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M323.018 74V99.2683H367.092V74C367.092 71.7909 365.302 70 363.092 70H327.018C324.808 70 323.018 71.7909 323.018 74Z"
        fill="#D9D9D9"
        fillOpacity="0.35"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M337.235 92.683H355.244L347.741 81.8699L343.238 88.0488L341.738 86.5041L337.235 92.683ZM339.395 82.736C339.818 83.1705 340.39 83.4147 340.987 83.4147C341.584 83.4147 342.157 83.1705 342.579 82.736C343.001 82.3015 343.238 81.7121 343.238 81.0976C343.238 80.4831 343.001 79.8937 342.579 79.4592C342.157 79.0246 341.584 78.7805 340.987 78.7805C340.39 78.7805 339.818 79.0246 339.395 79.4592C338.973 79.8937 338.736 80.4831 338.736 81.0976C338.736 81.7121 338.973 82.3015 339.395 82.736Z"
        fill="#A0A0A0"
      />
    </svg>
  )
}
